import { render } from "./BlogInOnLaysCare.vue?vue&type=template&id=999ebac8"
import script from "./BlogInOnLaysCare.vue?vue&type=script&lang=js"
export * from "./BlogInOnLaysCare.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__